// Empty experience object template used across onboarding forms
export const EMPTY_EXPERIENCE = {
  type: '',
  field: null,
  title: '',
  skills: [],
  start_date: null,
  end_date: null,
  employer_provider: '',
  comments: '',
};

// Military experience with default type
export const MILITARY_EMPTY_EXPERIENCE = {
  type: '',
  field: null,
  title: '',
  skills: [],
  start_date: null,
  end_date: null,
  employer_provider: '',
  comments: '',
  experienceCategory: '',
  branch: '',
  rank: '',
};
